export default {
  existing_documents: {
    description:
      'Poniższe dokumenty zostały już przesłane. Wybierz jeden i naciśnij „Wyślij" lub prześlij nowy dokument.',
    sides: {
      front: 'Przód',
      back: 'Tył',
    },
    created_at: 'Przesłano: {{date}}',
    expires_at: 'Wygasa: {{date}}',
  },
  document_types: {
    owner_document: 'Dokument tożsamości właściciela',
    business_document: 'Dokument firmowy',
  },
  form: {
    document_type: {
      label: 'Dokument potwierdzający działalność',
      placeholder: 'Wybierz typ dokumentu',
      options: {
        vat_registration: 'Rejestracja VAT',
        trade_registration: 'Rejestracja handlowa',
        trade_license: 'Licencja handlowa',
        commercial_register_extract: 'Wyciąg z rejestru handlowego',
        financial_statements: 'Sprawozdania finansowe',
        other: 'Inne',
      },
    },
    front: {
      label: 'Przód dokumentu',
    },
    back: {
      label: 'Tył dokumentu (opcjonalny dla niektórych dokumentów)',
    },
    expires_at: {
      label: 'Data ważności dokumentu',
      placeholder: 'Wybierz datę ważności',
    },
  },
  buttons: {
    select_file: 'Wybierz plik',
    next: 'Dalej',
    back: 'Tył',
    send: 'Wyślij',
    upload_new: 'Prześlij nowy dokument',
    use_existing: 'Użyj przesłanego dokumentu',
  },
};
